import { useCallback, useEffect, useState } from 'react';
import { tReturnForm } from '../contexts/zod';
import { useReturnContext } from '../contexts/returnContext';

const useStatusMessage = (orderLine: tReturnForm) => {
  const { returns } = useReturnContext();

  const [exists, setExists] = useState(false);
  const [numberOfItems, setNumberOfItems] = useState(0);

  const calculateReturns = useCallback(async () => {
    // only uid need to be checked here, however the uid in the returns is uid + returnCode
    const returnKeys = Object.keys(returns);
    // this could hit on several objects
    setExists(returnKeys.some((key) => key.includes(orderLine.uid)));
    const allReturnsMatchingOnId = returnKeys.filter((key) =>
      key.includes(orderLine.uid),
    );
    const totalQuantity = allReturnsMatchingOnId.reduce(
      (previousValue, currentValue) =>
        previousValue + returns[currentValue].returnData.amount,
      0,
    );
    setNumberOfItems(totalQuantity);
  }, [returns, orderLine.uid]);

  useEffect(() => {
    calculateReturns();
  }, [returns, calculateReturns]);

  return { calculateReturns, exists, numberOfItems };
};

export default useStatusMessage;
